<template>
<body>

<div>
    <div class="logo"></div>
  </div>
  <div id="mod1" class="center" style="height:1000px;">
    <div class="list">
      <h1>舟三信息科技（连云港）有限公司
      </h1>
    </div>

    <div class="list1">
      <h2>编号</h2>
      <h3>苏网文〔2024〕 0312-011号
      </h3>
    </div>

    <div class="list1">
      <h2>名称</h2>
      <h3>舟三信息科技（连云港）有限公司
      </h3>
    </div>
    <div class="list1">

      <h2>住所</h2>
      <h3>江苏省连云港市海州区凌州东路8号秀逸苏杭城市综合体商务办公楼411号
      </h3>
    </div>

    <div class="list1">
      <h2>实际经营地址</h2>
      <h3>江苏省-连云港市-海州区凌州东路8号秀逸苏杭城市综合体商务办公楼411号
      </h3>
    </div>

    <div class="list1">
      <h2>法定代表人</h2>
      <h3>程丹
	</h3>
    </div>

    <div class="list1">
      <h2>类型</h2>
      <h3>有限责任公司
      </h3>
    </div>

    <div class="list1">
      <h2>单位类别</h2>
      <h3>内资经营性互联网文化单位
      </h3>
    </div>

    <div class="list1">
      <h2>注册资本</h2>
      <h3>人民币100万
      </h3>
    </div>

    <div class="list1">
      <h2>首次发证日期</h2>
      <h3>2024-06-18
      </h3>
    </div>

    <div class="list1">
      <h2>有效期</h2>
      <h3>2024-06-18 至 2027-6-17
      </h3>
    </div>

    <div class="list1">
      <h2>经营范围</h2>
      <h3>利用信息网络经营表演。
      </h3>
    </div>

    <div class="list1">
      <h2>发证机关</h2>
      <h3>江苏省文化和旅游厅
      </h3>
    </div>

    <div class="list1">
      <h2>发证日期</h2>
      <h3>2024-06-18
      </h3>
    </div>

  </div>

</body>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped type="text/css">
html {
  -ms-text-size-adjust:100%;
  -webkit-text-size-adjust:100%;
}

body {
  width: 100%;
  font: normal 14px Helvetica, Arial, sans-serif;
  color: #666;
}
*{margin:0px; padding:0px;}

.logo {
  width:100%;
  height:72px;
  background: #EBEBEB url(../assets/logo.png) left center no-repeat;
  background-size:contain;
}

.center{ overflow-x:hidden; overflow-y:auto;}
.list {
  width: 100%;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom:solid 1px #dcdcdc
}
.list1 {
  width: 100%;
  height: auto;
  border-bottom: solid 1px #dcdcdc;
  padding-top: 5px;
  padding-bottom: 0px;
}
h1 {
  font-size:1.4em;
  font-weight:600;
  margin:0px 20px;
  text-align:left;
}
h2{
  font-size:1em;
  font-weight:600;
  line-height:20px ;
  text-indent:24px;
  background:url(../assets/list.png) no-repeat;
  margin:8px 16px auto 16px;
  text-align:left;
}
h3 {
  font: normal 1.285em "微软雅黑";
  margin:0px 16px 8px 40px;
  text-align:left;
}

</style>

